import styled from 'styled-components/macro';

export const Container = styled.div`
  margin: 20px 0;
`;
